import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRect = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		width: 100,
		height: 100,
		fill: "currentColor",
		rx: 10
	})
});
export default SvgRect;
